export default "__VITE_ASSET__Cig4ekGC__"